import { AlertService } from './../../services/alert.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IResponseObject } from 'src/app/models/response-object.model';
import { MoneyPolicy } from 'src/app/models/responseMoneySrcPolicy';
import { MoneyPolicyService } from 'src/app/services/money-policy.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-moneysrc-policy',
  templateUrl: './moneysrc-policy.component.html',
  styleUrls: ['./moneysrc-policy.component.scss']
})
export class MoneysrcPolicyComponent implements OnInit {
  title: string;
  description: string;
  textCheckbox: string;
  accepted: boolean;
  @Output() policySaved = new EventEmitter<boolean>();
  @Input() countryPolicyData: IResponseObject<MoneyPolicy>;


  constructor(
    private readonly moneyPolicyService: MoneyPolicyService,
    private readonly alertService: AlertService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.accepted = false;
    this.title = this.countryPolicyData.DATA.title;
    this.description = this.countryPolicyData.DATA.description;
    this.textCheckbox = 'Acepto ' + this.title.toLowerCase();

  }

  saveAcceptanceMoneyPolicy(): void{
    this.moneyPolicyService.saveAcceptanceMoneySrcPolicy().subscribe((response:IResponseObject<null>) => {
      if(response.CODE != '0000'){
        this.alertService.showAlertProblem(() => {
          this.router.navigate(['/error']);
        });
      }
      else{
        this.policySaved.emit(true)
      }
    }, (error: any) => {
      this.alertService.showAlertProblem(() => {
        this.router.navigate(['/error']);
      });
    });
  }

}
